// @flow

import _ from 'lodash';

import type { LogContextInterface } from 'log-context';


type FileUploadInputParams = {
	file?: any,
	maxFileSize?: number,
	placeholder?: any,
	logContext?: LogContextInterface,
	attributes?: Object,
};

export class FileUploadInputViewModel {
	_params: FileUploadInputParams;

	constructor (params: FileUploadInputParams) {
		this._params = params = _.defaults({}, params, {
			file: undefined,
			maxFileSize: undefined,
			placeholder: undefined,
			logContext: undefined,
			attributes: undefined,
		});
	}
}